import Enum from "../Enum";

export default Enum.create( {
	CHANGE: "CHANGE",
	ERROR: "ERROR",
} );
